import Request from './request';
import * as log from 'loglevel';
import Util from './util';

class Translate {
    static get(key, params, fallback){
        // return translation or the key itself if not found NEW: fallback last param
        let t = Translate.translations[key] || (fallback || key);
        // replace all params in translation
        if(params){
            for(let key in params){
                if(params.hasOwnProperty(key)){
                    t = t.replace(new RegExp('{' + key + '}', 'g'), params[key]);
                }
            }
        }
        return t;
    }

    // translate input string with key prefix syntax
    static translate(input, params){
        if(input && typeof input === 'string'){
            // direct translate key
            if(input.charAt(0) === '#'){
                return Translate.get(input.substr(1).trim(), params);
            }
            // embedded string key
            else if(input.indexOf('#{') !== -1){
                let filteredValue = input;
                while(filteredValue.indexOf('#{') !== -1){

                    let startIndex = filteredValue.indexOf("#{");
                    let endIndex = filteredValue.indexOf("}", startIndex);
                    let key = filteredValue.substring(startIndex+2,endIndex);

                    let keyValue = Translate.get(key, params);

                    filteredValue = filteredValue.replace('#{'+key+'}',keyValue);
                }
                return filteredValue;
            }
        }
        // no key
        return input;
    }

    static fetch(locale){

        let requestUrl = Translate.api.replace('{locale}', locale);

        let request = new Request(requestUrl, { method: 'GET'});

        Translate.ready = request.then((response) => {

            log.debug('[translate] ' + requestUrl + ' response', response.data);

            Translate.update(response.data);

            return Translate.translations;
        }).catch((error) => {

            log.error('[translate] ' + requestUrl + ' error', error);

            // always return OK
            return Translate.translations;
        });

        return Translate.ready;
    }

    static update(translations){
        // overwrite provided translations
        Translate.translations = Util.extend(Translate.translations, translations);

        // trigger event
        Translate.updated();
    }

    static updated(){
        const event = new CustomEvent(Translate.event, { detail: {}, cancelable: true, bubbles: true });
        window.dispatchEvent(event);
    }

    static onUpdated(listener){
        window.addEventListener(Translate.event, listener);
    }
}
// current browser locale (shopify global var set OR fallback to <html lang=""> attribute - can be empty "")
Translate.locale = window.Shopify && window.Shopify.locale ? window.Shopify.locale : document.documentElement.lang;
Translate.translations = {};
Translate.ready = Promise.resolve(true);
Translate.event = 'cloudlift.translate';
Translate.api = '';

export default Translate;